const {
  MOBILE_DEVICE,
  TABLET_DEVICE,
  DESKTOP_DEVICE,
  BOT,
  GOOGLEBOT,
} = require("./deviceConstants");

const testUserAgent = (userAgent, expr) => {
  return expr.test(userAgent);
};

const isIpad = (userAgent) => {
  return testUserAgent(userAgent, /iPad/i);
};

const isIphone = (userAgent) => {
  return testUserAgent(userAgent, /iPhone/i);
};
const isIpod = (userAgent) => {
  return testUserAgent(userAgent, /iPod/i);
};

const isIOS = (userAgent) => {
  return testUserAgent(userAgent, /iPad|iPhone|iPod/i);
};

const isAndroid = (userAgent) => {
  return testUserAgent(userAgent, /android/i);
};

const isMobileDevice = (userAgent) => {
  return testUserAgent(userAgent, /Mobile/i);
};

const isTabletDevice = (userAgent) => {
  return testUserAgent(userAgent, /Tablet|Silk/i);
};

const detectDeviceType = (userAgent) => {
  let device = DESKTOP_DEVICE;
  if (isMobileDevice(userAgent) && !isIpad(userAgent)) {
    device = MOBILE_DEVICE;
  } else if (isIpad(userAgent) || isAndroid(userAgent) || isTabletDevice(userAgent)) {
    device = TABLET_DEVICE;
  }
  return device;
};

const detectBot = (userAgent) => {
  return testUserAgent(userAgent, BOT);
};

const detectGoogleBot = (userAgent) => {
  return testUserAgent(userAgent, GOOGLEBOT);
};

const isMobile = (userAgent) => detectDeviceType(userAgent) === MOBILE_DEVICE;
const isTablet = (userAgent) => detectDeviceType(userAgent) === TABLET_DEVICE;
const isDesktop = (userAgent) => detectDeviceType(userAgent) === DESKTOP_DEVICE;

module.exports = {
  isIpad,
  isIphone,
  isIOS,
  isAndroid,
  isMobileDevice,
  isTabletDevice,
  detectDeviceType,
  detectBot,
  detectGoogleBot,
  isMobile,
  isTablet,
  isDesktop,
  isIpod,
};
